import React, {Component} from 'react'
import {withStyles} from '@material-ui/core'
import style from './style'
import ImportantButton from '../ImportantButton';

/**
 * These are the buttons displayed at the bottom section of the Payment forms. Shows the Cancel and Submit buttons.
 */
class PaymentButtons extends Component {
    /**
     * Renders the both buttons.
     *
     * @returns JSX representing the visual structure of this component.
     */
    render() {
        const {
            classes,
            hasErrors,
            cancelUrl,
            submitButtonText = "Pagar"
        } = this.props

        return (
            <div className={classes.main}>
                <a className={classes.cancelButton}
                   id="cancel-button"
                   href={cancelUrl}
                   tabIndex={18}>
                    Cancelar
                </a>

                <ImportantButton
		    type="submit"
                    disabled={hasErrors}
                    id="submit"
                    tabIndex={17}>{submitButtonText}</ImportantButton>
            </div>
        )
    }
}

export default withStyles(style)(PaymentButtons)
